import styled from "styled-components";
import { veryLightGrey } from "../../components/colors";

export const StudentActivityDataCircle = styled.div`
  margin: 1em;
  line-height: 4em;
  text-align: center;
  font-size: medium;
  width: 4em;
  height: 4em;
  background-color: ${veryLightGrey};
  border-radius: 2em;
`;
